import "./AppHeader.css";
import { IconRotateCcw, IconTriangleAlert } from "../Icon/Icon.jsx";
import { AltHintTarget } from "../AltHintTarget/AltHintTarget.jsx";

function splitTabsIntoRegions(tabs) {
  const pivotIndex = tabs.findIndex((tab) => tab.end);
  if (pivotIndex < 0) {
    return {
      leftTabs: tabs,
      rightTabs: []
    };
  }

  return {
    leftTabs: tabs.slice(0, pivotIndex),
    rightTabs: tabs.slice(pivotIndex)
  };
}

function visibleYearRail(yearOptions, activeYear) {
  const activeIndex = yearOptions.findIndex((year) => year === activeYear);
  if (activeIndex < 0) {
    return yearOptions.slice(0, 3);
  }

  if (yearOptions.length <= 3) {
    return yearOptions;
  }

  if (activeIndex <= 0) {
    return yearOptions.slice(0, 3);
  }

  if (activeIndex >= yearOptions.length - 1) {
    return yearOptions.slice(-3);
  }

  return yearOptions.slice(activeIndex - 1, activeIndex + 2);
}

function TabList({ currentPage, tabs, showAltHints, hintOffset = 0 }) {
  return tabs.map((item, index) => (
    <AltHintTarget
      as="a"
      label={String(hintOffset + index + 1)}
      visible={showAltHints}
      className={`tab${currentPage === item.key ? " active" : ""}`}
      href={item.href}
      key={item.key}
    >
      {item.label}
    </AltHintTarget>
  ));
}

export function AppHeader({
  currentPage,
  tabs,
  alert = null,
  t = (key) => key,
  activeYear = "",
  yearOptions = [],
  onYearChange = null,
  showAltHints = false
}) {
  const { leftTabs, rightTabs } = splitTabsIntoRegions(tabs);
  const railYears = visibleYearRail(yearOptions, activeYear);
  const AlertIcon = alert?.icon === "refresh" ? IconRotateCcw : IconTriangleAlert;

  return (
    <header class="app-header">
      <div class="app-header-inner">
        <nav class="tabs tabs--left">
          <TabList currentPage={currentPage} tabs={leftTabs} showAltHints={showAltHints} />
        </nav>

        {yearOptions.length > 1 ? (
          <AltHintTarget
            label="Y"
            visible={showAltHints}
            className="app-header-year-rail-wrap"
          >
            <div class="app-header-year-rail">
              {railYears.map((year) => (
                <button
                  key={year}
                  class={`app-header-year${year === activeYear ? " active" : ""}`}
                  type="button"
                  onClick={() => onYearChange?.(year)}
                >
                  {year}
                </button>
              ))}
            </div>
          </AltHintTarget>
        ) : (
          <div class="app-header-year-rail app-header-year-rail--empty" />
        )}

        <nav class="tabs tabs--right">
          {alert ? (
            alert.href ? (
              <AltHintTarget
                as="a"
                visible={showAltHints}
                className="tab tab--alert"
                href={alert.href}
              >
                <AlertIcon className="tab-alert-icon" />
                <span>{alert.label ?? t("alert")}</span>
              </AltHintTarget>
            ) : (
              <AltHintTarget
                as="button"
                visible={showAltHints}
                className="tab tab--alert"
                type="button"
                onClick={alert.onClick}
              >
                <AlertIcon className="tab-alert-icon" />
                <span>{alert.label ?? t("alert")}</span>
              </AltHintTarget>
            )
          ) : null}
          <TabList
            currentPage={currentPage}
            tabs={rightTabs}
            showAltHints={showAltHints}
            hintOffset={leftTabs.length}
          />
        </nav>
      </div>
    </header>
  );
}
